export const calcularPromediosDRC = (datosDRC) => {
    let drc_promedio = 0;
    let drc_minimo = 0;
    let drc_maximo = 0;
    let drc_diferencia = 0;

    if (datosDRC.length === 0) {
        return { drc_promedio, drc_minimo, drc_maximo, drc_diferencia };
    }

    // CALCULAR ÚNICO DRC PROMEDIO EN BASE A LOS drc_promedio_total de los datosDRC
    const drc_promedios = datosDRC.map((dato) => dato.drc_promedio_total);

    drc_promedio =
        drc_promedios.reduce((a, b) => a + b, 0) / drc_promedios.length;
    drc_minimo = Math.min(...drc_promedios);
    drc_maximo = Math.max(...drc_promedios);
    drc_diferencia = drc_maximo - drc_minimo;

    return { drc_promedio, drc_minimo, drc_maximo, drc_diferencia };
};
